import { useCallback, useEffect, useRef, useState } from 'react';
import { supabase } from '../lib/supabaseClient';

// In-app delivery of Ava (آوا) proactive notifications. Subscribes to INSERTs on
// public.ava_notifications via supabase realtime (the same postgres_changes
// fabric as useOpenRouterBalance / dreaming_jobs, carried by the /sb proxy +
// attachSupabaseRealtimeProxy). RLS restricts the table to admins, so a non-
// admin session receives nothing. Each new row becomes a toast that auto-
// dismisses after AUTO_DISMISS_MS or on manual close.
//
// This is the "tab open" channel; Web Push (increment 2) covers a closed tab.

const AUTO_DISMISS_MS = 10000;
let SEQ = 0;

export function useAvaNotifications() {
  const [toasts, setToasts] = useState([]);
  const timersRef = useRef({});

  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
    const tm = timersRef.current[id];
    if (tm) { clearTimeout(tm); delete timersRef.current[id]; }
  }, []);

  const push = useCallback((row) => {
    if (!row || (!row.title && !row.body)) return;
    SEQ += 1;
    const id = `ava-n-${SEQ}`;
    setToasts((prev) => [...prev, {
      id,
      title: row.title || 'آوا',
      body: row.body || '',
      kind: row.kind || 'reminder',
    }]);
    timersRef.current[id] = setTimeout(() => dismiss(id), AUTO_DISMISS_MS);
  }, [dismiss]);

  useEffect(() => {
    const channel = supabase
      .channel('ava_notifications_toasts')
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'ava_notifications' },
        (payload) => push(payload && payload.new),
      )
      .subscribe();

    const timers = timersRef.current;
    return () => {
      supabase.removeChannel(channel);
      Object.values(timers).forEach((tm) => clearTimeout(tm));
    };
  }, [push]);

  return { toasts, dismiss };
}
